import api from './api';

export const getMentorProfile = async () => {
  const response = await api.get('/api/mentors/me');
  return response.data;
};

export const updateMentorProfile = async (formData) => {
  const response = await api.put('/api/mentors/me', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const applyAsMentor = async (formData) => {
    const response = await api.post('/api/mentors/apply', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
};

export const getAllMentors = async () => {
    const response = await api.get('/api/mentors');
    return response.data;
};

export const requestMentorship = async (data) => {
    const response = await api.post('/api/mentors/request', data);
    return response.data;
};

export const getMentorRequests = async () => {
    const response = await api.get('/api/mentors/my-requests');
    return response.data;
};

export const updateRequestStatus = async (requestId, status) => {
    const response = await api.put(`/api/mentors/request/${requestId}`, { status });
    return response.data;
};
